import { makeStyles, useTheme } from '@pickupp/ui/styles'
import chroma from 'chroma-js'
import cx from 'classnames'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import { BlockContext } from '~/src/contexts'

import styles from './styles'

const useStyles = makeStyles(styles)

const Block = (props) => {
  const {
    containerClassName,
    foregroundClassName,
    backgroundClassName,
    color,
    fullWidth,
    children,
    backgroundImage: bgImageProps,
    backgroundDimValue,
  } = props

  const classes = useStyles()
  const theme = useTheme()

  const context = useContext(BlockContext)

  // Use block color if specify
  // Otherwise, use context color and fallback to `white` if context is not set
  const bgColor = color || context?.backgroundColor || 'white'
  const gradient = context ? context.gradient : false
  const transparent = context ? context.transparent : false
  const identity = `${context?.typeName}_${context?.data?.id}`

  const keyColor = theme.palette.common[bgColor]
  const backgroundColor = keyColor
  let backgroundImage = null
  if (keyColor && gradient && !bgImageProps) {
    const darkColor = chroma(keyColor).darken(1).hex()
    backgroundImage = `linear-gradient(to top, ${darkColor} 0%, ${keyColor} 100%)`
  }
  if (bgImageProps) {
    backgroundImage = `linear-gradient(to top, rgba(0, 0, 0, ${backgroundDimValue}), rgba(0, 0, 0, ${backgroundDimValue})), url('${bgImageProps}')`
  }

  return (
    <div
      className={cx(
        classes.container,
        containerClassName,
      )}
      id={identity}
      data-block={context && context.typeName}
    >
      <div
        className={cx({
          [classes.foreground]: true,
          [classes.fullWidth]: fullWidth,
          [foregroundClassName]: !!foregroundClassName,
        })}
      >
        {children}
      </div>
      <div
        className={cx({
          [classes.background]: true,
          [classes.transparent]: transparent,
          [backgroundClassName]: !!backgroundClassName,
        })}
        style={{
          backgroundColor,
          backgroundImage,
        }}
      />
    </div>
  )
}

Block.propTypes = {
  containerClassName: PropTypes.string,
  foregroundClassName: PropTypes.string,
  backgroundClassName: PropTypes.string,
  color: PropTypes.string,
  fullWidth: PropTypes.bool,
  children: PropTypes.node,
  backgroundImage: PropTypes.string,
  backgroundDimValue: PropTypes.number,
}

Block.defaultProps = {
  containerClassName: null,
  foregroundClassName: null,
  backgroundClassName: null,
  color: null,
  fullWidth: false,
  children: null,
  backgroundImage: null,
  backgroundDimValue: 0.6,
}

export default Block
